module.exports = __webpack_public_path__ + "static/media/IMG_E2915a.bc9bd4c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/andes/IMG_E2915a.jpg
// module id = 144
// module chunks = 0